import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import { Table, TableHeader, TableCell, TableBody, DataTableCell } from '@david.kucsai/react-pdf-table';

// Create styles
const styles = StyleSheet.create({
  page: {
    padding: 10
  },
  header: {
    marginLeft: 10,
    marginRight: 10,
    marginTop: 5,
    marginBottom: 10,
    fontSize: 10,
    textAlign: "center"
  },
  university: {
    fontSize: 8,
    paddingBottom: 4
  },
  college: {
    fontSize: 13,
    fontWeight: "black",
    paddingBottom: 4
  },
  section: {
    marginLeft: 10,
    marginRight: 10,
    marginTop: 5,
    marginBottom: 3
  },
  row: {
    display: "flex",
    flexDirection: "row"
  },
  column: {
    width: "50%",
    fontSize: 11,
    paddingBottom: 5
  },
  table: {
    marginTop: "-40px"
  },
  tableCell: {
    fontSize: 10,
    padding: 3,
    wordBreak: "break-all",
    whiteSpace: "pre-wrap"
  },
  snCell: {
    maxWidth: "30px",
    minWidth: "30px",
    width: "30px"
  },
  rollCell: {
    maxWidth: "80px",
    minWidth: "80px",
    width: "80px"
  },
  ansCell: {
    maxWidth: "80px",
    minWidth: "80px",
    width: "80px"
  },
  sigCell: {
    maxWidth: "60px",
    width: "60px",
    textAlign: "center"
  },
  nameCell: {
    maxWidth: "210px",
    minWidth: "210px",
    width: "210px"
  },
  footer: {
    display: "flex",
    flexDirection: "row",
    marginLeft: 10,
    marginRight: 10,
    marginTop: "50px",
    marginBottom: 5,
    justifyContent: "space-between"
  },
  footerCol: {
    width: '30%',
    fontSize: 11,
    textAlign: "center"
  },
  footerLeftCol: {
    width: "80px",
  },
  footerRightCol: {
    width: "80px",
  },
  watermark: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transform: [{ rotate: '45deg'}]
  },
  watermarkText: {
    color: "#ddd",
    opacity: 0.8,
    fontSize: 180
  }
});

class AttendanceSheet extends Component {
  render() {
    const { attendanceData, fromData } = this.props
    
    return (
      <Document
        author="Manish Baral"
        creator="Manish Baral"
      >
        {
          attendanceData.map(a => {
            return a.attendence.map((s, i) => {
              const student = s.map((r, i) => {
                return {
                  id: i + 1,
                  firstAns: null,
                  lastNas: null,
                  sig: null,
                  ...r
                }
              })

              return (
                <Page style={styles.page} key={i}>
                  <View style={styles.watermark}>
                    <Text style={styles.watermarkText}>DRAFT</Text>
                  </View>
                  <View style={styles.header}>
                    <Text style={styles.university}>{ fromData.university }</Text>
                    <Text style={styles.college}>{ fromData.college }</Text>
                    <Text>EXAMINEES ATTENDANCE</Text>
                  </View>
                  <View style={styles.section}>
                    <View style={styles.row}>
                      <View style={styles.column}>
                        <Text>Date: { fromData.date }</Text>
                      </View>
                      <View style={styles.column}>
                        <Text>Exam Center: { fromData.examCenter }</Text>
                      </View>
                    </View>

                    <View style={styles.row}>
                      <View style={styles.column}>
                        <Text>Level: { fromData.level }</Text>
                      </View>
                      <View style={styles.column}>
                        <Text>Room No: { a.roomName }</Text>
                      </View>
                    </View>

                    <View style={styles.row}>
                      <View style={styles.column}>
                        <Text>Programme: { fromData.program }</Text>
                      </View>
                      <View style={styles.column}>
                        <Text>Year/Semester: { fromData.semester }</Text>
                      </View>
                    </View>

                    <View style={styles.row}>
                      <View style={styles.column}>
                        <Text>Subject:  { fromData.subject }</Text>
                      </View>
                      <View style={styles.column}>
                        <Text>Time: { fromData.time }</Text>
                      </View>
                    </View>

                    <View style={styles.row}>
                      <View style={styles.column}>
                        <Text>Subject Code No.: { fromData.subjectCode }</Text>
                      </View>
                      <View style={styles.column}>
                        <Text>Duration: { fromData.duration }</Text>
                      </View>
                    </View>
                  </View>
                  
                  <View style={styles.section}>
                    <Table style={styles.table} data={student}>
                      <TableHeader>
                        <TableCell style={[styles.tableCell, styles.snCell]}>S.N</TableCell>
                        <TableCell style={[styles.tableCell, styles.rollCell]}>Exam Roll No.</TableCell>
                        <TableCell style={[styles.tableCell, styles.nameCell]}>Name of the Student (BLOCK LETTER)</TableCell>
                        <TableCell style={[styles.tableCell, styles.ansCell]}>First Answer Sheet No.</TableCell>
                        <TableCell style={[styles.tableCell, styles.ansCell]}>Second Answer Sheet No.</TableCell>
                        <TableCell style={[styles.tableCell]}>Signature</TableCell>
                      </TableHeader>
                      <TableBody>
                        <DataTableCell style={[styles.tableCell, styles.snCell]} getContent={(r) => r.id}/>
                        <DataTableCell style={[styles.tableCell, styles.rollCell]} getContent={(r) => r.examRollNumber}/>
                        <DataTableCell style={[styles.tableCell, styles.nameCell]} getContent={(r) => r.studentName.toUpperCase()}/>
                        <DataTableCell style={[styles.tableCell, styles.ansCell]} getContent={(r) => r.firstAns}/>
                        <DataTableCell style={[styles.tableCell, styles.ansCell]} getContent={(r) => r.lastNas}/>
                        <DataTableCell wstyle={[styles.tableCell]} getContent={(r) => r.sig}/>
                      </TableBody>
                    </Table>
                  </View>

                  <View style={styles.footer}>
                    <View style={[styles.footerCol, styles.footerLeftCol]}>
                      <Text>.....................</Text>
                      <Text>Invigilator</Text>
                    </View>
                    <View style={[styles.footerCol, styles.footerCenterCol]}>
                      <Text style={{marginBottom: 4}}>Number of Present Student:</Text>
                      <Text>Number of Abscent Student:</Text>
                    </View>
                    <View style={[styles.footerCol, styles.footerRightCol]}>
                      <Text>.....................</Text>
                      <Text>Superintendent</Text>
                    </View>
                  </View>
                </Page>
              )
            })
          })
        }
        
      </Document>
    )
  }
}

AttendanceSheet.propTypes = {
  attendanceData: PropTypes.array,
  fromData: PropTypes.object
}

export default AttendanceSheet
